import { render, staticRenderFns } from "./EmployeePayrollDetails.vue?vue&type=template&id=5f4cb948&scoped=true&"
import script from "./EmployeePayrollDetails.vue?vue&type=script&lang=ts&"
export * from "./EmployeePayrollDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeePayrollDetails.vue?vue&type=style&index=0&id=5f4cb948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cb948",
  null
  
)

export default component.exports